import React, {useState} from "react";
import {Link} from "react-router-dom";
import enFlag from "../static/img/BritishFlag.png";
import ukrFlag from "../static/img/UkrainianFlag.png";
import meeting1 from "../static/img/meeting1.jpg";
import meeting2 from "../static/img/meeting2.jpg";
import "./Microcredit.style.scss";

const OnlineMeeting: React.FC = ()=> {
    const [isHovered, setIsHovered] = useState({on: false, index: 0});
    const [en, setEn] = useState(false);
    return (
        <div style={{marginTop:"30px",marginBottom:"20px"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",marginBottom:"50px"}} >
                <Link to={"/"} className={"consortium_link"}
                      style={(isHovered.on && isHovered.index === 0) ? {color:"gray",boxShadow:"3px 3px 3px"} : {color:"white"}}
                      onMouseEnter={() => setIsHovered({on:true,index:0})}
                      onMouseLeave={() => setIsHovered({on:false,index:0})}
                >&#8592; Back</Link>
                <button className={"consortium_button"}
                        onClick={()=> setEn(!en)} >
                    {en ? <img src={ukrFlag} alt="flag"/> : <img src={enFlag} alt="flag"/>}
                </button>
            </div>
            <h1>
                {en ? "Online meeting 27.11.2024" : "Онлайн-зустріч 27.11.2024"}
            </h1>
            <p style={{fontWeight:"inherit",fontSize: "20px",margin:"30px 120px 30px 120px",textAlign:"left"}}>
                {en ? "The first kick-off meeting was held online in Zoom, where the partners got to know each other and discussed the main provisions of the project. " +
                    "The project coordinator Kristina Marran, Head of Estonian University of Life Sciences Open University, reminded us of our roles, according to the plan," +
                    " and what awaits us in the near future. The financial part of the project was also discussed." : "Перша стартова зустріч відбулась онлайн у Zoom, де" +
                    " відбулось знайомство партнерів між собою та обговорено основні положення проекту. " +
                    "Координатор проєкту Kristina Marran, Керівник Відкритого університету Естонського університету наук про життя, нагадала нам наші ролі, згідно плану та те," +
                    " що нас чекає найближчим часом. Також було обговорено фінансову частину проєкту."}
            </p>
            <img style={{width:"75%"}} src={meeting1} alt="meeting"/>
            <img src={meeting2} alt="meeting"/>
        </div>
    )
}
export default OnlineMeeting;